import { Box } from "@mui/material"
import { useState } from "react"

interface SettingsBooleanOptionSelectorProps {
    settingName: string
}


const SettingsBooleanOptionSelector = (props: SettingsBooleanOptionSelectorProps) => {

    let [activate, setActivate] = useState(false)

    const onClick = () => {
        setActivate(!activate)
    }
    return <Box display={"flex"} onClick={onClick} flexDirection={"column"} justifyContent={"center"} maxWidth={"150px"}>
    <Box display={"flex"} justifyContent={"center"}  sx={{textDecoration: activate ? "inherit" : "line-through", opacity: activate ? 1 : 0.5}}>{props.settingName}</Box>

</Box>
}

export default SettingsBooleanOptionSelector